import { jsx as r } from "react/jsx-runtime";
import e from "@kmx/mui-icons/KmxClearFilled";
const t = (a, i) => ({
  props: {
    variant: "weak",
    color: i
  },
  style: {
    background: a.palette[i].faint,
    color: a.palette[i].main,
    ".MuiChip-deleteIcon": {
      color: "currentColor"
    },
    "&.MuiChip-clickable:hover": {
      background: a.palette[i].dark,
      color: a.palette[i].contrastText,
      ".MuiChip-deleteIcon": {
        opacity: ".7",
        "&:hover": {
          opacity: "initial"
        }
      }
    },
    "&.Mui-focusVisible": {
      background: a.palette[i].dark,
      color: a.palette[i].contrastText
    },
    "&:disabled": {
      background: a.palette[i].faint,
      opacity: "0.38"
    },
    "&.MuiChip-clickable:active": {
      background: a.palette[i].dark
    }
  }
}), l = {
  defaultProps: {
    deleteIcon: /* @__PURE__ */ r(e, {})
  },
  styleOverrides: {
    root: ({ theme: a }) => ({
      variants: [
        t(a, "primary"),
        t(a, "secondary"),
        t(a, "error"),
        t(a, "warning"),
        t(a, "info"),
        t(a, "success"),
        t(a, "flagged")
      ]
    })
  }
};
export {
  l as default
};
